import { isEqual } from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ON_FORM_CHANGE, SET_API_DATA, SET_ERROR } from "../redux/constants";
import { checkValid } from "../shared/validation";
import {
  setErrors,
  toggleModelShow,
  clearFormData,
} from "../shared/CustomFunc";
import { ApiContainer } from "../utils/api";
import { department_admin } from "../utils/constant";

const formPath = { parent: "EventEmailConfig" };

const EventCommunicationContainer = () => {
  const dispatch = useDispatch();
  const { api } = ApiContainer();
  const { eventId, organizationId, locationId, departmentId } = useParams();
  const { form } = useSelector((state) => state);
  const role = useSelector((state) => state?.app?.userData?.user_profile?.role);
  const EventEmailConfig = useSelector(
    (state) => state.form.formData?.[formPath.parent]
  );
  const EventEmailConfigToEdit = useSelector(
    (state) => state.api.EventEmailConfigToEdit
  );
  const eventCommunicationList = useSelector(
    (state) => state.api.eventCommunicationList
  );
  const emailPreviewResult = useSelector(
    (state) => state.api.emailPreviewResult
  );
  const formDataError = useSelector(
    (state) => state.form.formErrors?.[formPath.parent]
  );
  const formData = useSelector(
    (state) => state.form.formData?.[formPath.parent]
  );
  const modelState = useSelector((state) => state?.modelStates);

  const loaders = useSelector((state) => {
    return {
      eventCommunicationList: state.api?.loader?.eventCommunicationList,
      createEventSchedule: state.api?.loader?.createEventSchedule,
      documentResult: state.api?.loader?.documentResult,
      emailPreviewResult: state.api?.loader?.emailPreviewResult,
      UpdateEventSchedule: state.api?.loader?.UpdateEventSchedule,
      toggalAndDateChange: state.api?.loader?.toggalAndDateChange,
    };
  });

  const eventEndPoints = `organization/${organizationId}/locations/${locationId}/departments/${departmentId}/event-schedule/${eventId}`;

  const createEventCommunicationAttribute = [
    {
      label: "TURN ON EMAIL FLOW",
      md: 12,
      value: [
        {
          control: "input",
          label: "Additional Note",
          type: "text",
          name: "additional_note",
          value: "",
          placeHolder: "Please add additional note here",
          fullWidth: true,
          md: 12,
          readOnly: role === department_admin,
        },
      ],
    },
  ];
  const [loadingSwitchId, setLoadingSwitchId] = useState(null);

  const getEventCommunicationList = async ({ needLoader }) => {
    const response = await api({
      method: "GET",
      endPoint: `${eventEndPoints}/email-events-list`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: needLoader !== "false",
      parent: "eventCommunicationList",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          eventCommunicationList: response?.data,
        },
      });
    }
  };

  const setFormData = (name, value) => {
    dispatch(setErrors({ errors: formDataError, value, name, formPath }));
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...form.formData,
          [formPath.parent]: { ...formData, [name]: value },
        },
      },
    });
  };

  const handleViewEventSchedule = async (eventId) => {
    if (eventId) {
      const data = await api({
        method: "GET",
        endPoint: `${eventEndPoints}/email-config`,
        showToastMessage: false,
        urlencoded: false,
        needLoader: true,
        parent: "createEventSchedule",
        needFullResponse: false,
      });
      if (data?.status) {
        dispatch({
          type: SET_API_DATA,
          payload: {
            EventEmailConfigToEdit: data?.data,
          },
        });
        dispatch({
          type: ON_FORM_CHANGE,
          payload: {
            formData: {
              ...form.formData,
              EventEmailConfig: data?.data,
            },
          },
        });
      }
    }
  };

  const apiCall = async () => {
    const data = await api({
      method: "PUT",
      endPoint: `${eventEndPoints}/email-config
`,
      data: EventEmailConfig,
      showToastMessage: true,
      urlencoded: false,
      needLoader: true,
      parent: "UpdateEventSchedule",
    });

    if (data) {
      const dataUpdate = await api({
        method: "GET",
        endPoint: `${eventEndPoints}/email-config`,
        showToastMessage: false,
        urlencoded: false,
        needLoader: false,
        parent: "createEventSchedule",
        needFullResponse: false,
      });
      if (dataUpdate) {
        dispatch({
          type: SET_API_DATA,
          payload: {
            EventEmailConfigToEdit: dataUpdate?.data,
          },
        });
      }
    }
  };

  const handleCreateEventCommunication = (e) => {
    e.preventDefault();
    let errors = {};

    createEventCommunicationAttribute?.forEach((item) => {
      Object.values(item.value)?.forEach((control) => {
        const { name, validateAs, label } = control;
        errors = {
          ...errors,
          [name]: validateAs
            ? checkValid({
                validateAs,
                name,
                value: EventEmailConfig?.[name],
                label,
              })
            : false,
        };
      });
    });

    dispatch({
      type: SET_ERROR,
      payload: {
        formErrors: {
          ...form.formErrors,
          [formPath.parent]: { ...errors },
        },
      },
    });

    const hasErrors = Object.values(errors).some((err) => err);

    if (!hasErrors) {
      apiCall();
    }
  };

  const isSameConfig = isEqual(EventEmailConfig, EventEmailConfigToEdit);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files?.length > 0) {
      const file = files[0];
      const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");
      if (!isCSV) {
        dispatch({
          type: SET_ERROR,
          payload: {
            formErrors: {
              ...form.formErrors,
              [formPath.parent]: {
                ...formDataError,
                [name]: "Only CSV files are allowed",
              },
            },
          },
        });
        setFormData(name, null);
        return;
      }
      dispatch({
        type: SET_ERROR,
        payload: {
          formErrors: {
            ...form.formErrors,
            [formPath.parent]: {
              ...formDataError,
              [name]: "",
            },
          },
        },
      });

      setFormData(name, file);
    } else {
      setFormData(name, value);
    }
  };
  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData(name, checked);
  };

  const handleScheduledDateChange = async (email, type, from) => {
    if (!email) return;
    if (from === "toggle") {
      setLoadingSwitchId(email);
    }
    const payload =
      from === "date" ? { scheduled_date: type } : { send_email: type };
    const data = await api({
      method: "PUT",
      endPoint: `${eventEndPoints}/email-events/${email}`,
      data: payload,
      showToastMessage: true,
      urlencoded: false,
      needLoader: false,
    });
    if (from === "toggle") {
      setLoadingSwitchId(null);
    }
    if (data?.status) {
      getEventCommunicationList({ needLoader: false });
    }
  };

  const handleEmailPreview = async (email, type) => {
    const response = await api({
      method: "GET",
      endPoint: `${eventEndPoints}/email-preview?${
        email ? `email_type=${email}` : ""
      }${type ? `&service_level=${type}` : ""}`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "emailPreviewResult",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          emailPreviewResult: response?.data,
        },
      });
    }
  };

  useEffect(() => {
    handleViewEventSchedule(eventId);
  }, [eventId]);

  useEffect(() => {
    if (EventEmailConfigToEdit?.send_emails) {
      getEventCommunicationList({ needLoader: true });
    }
  }, [EventEmailConfigToEdit?.send_emails]);

  return {
    eventCommunicationList,
    dispatch,
    modelState,
    handleEmailPreview,
    handleScheduledDateChange,
    emailPreviewResult,
    handleSwitchChange,
    formPath,
    handleChange,
    handleCreateEventCommunication,
    loaders,
    loadingSwitchId,
    EventEmailConfigToEdit,
    isSameConfig,
  };
};

export default EventCommunicationContainer;
